/* PD Bandeau d'annonce : un message visible à la fois, changement en fondu,
   pause au survol / au focus, flèches précédent / suivant.
   Mobile : chaque message tient sur une ligne (taille réduite jusqu'à 9 px si besoin). */
(function () {
  const mobile = window.matchMedia('(max-width: 749px)');

  function fit(message) {
    message.style.removeProperty('--pd-annonce-fit');
    if (!mobile.matches) return;
    let size = parseFloat(getComputedStyle(message).fontSize);
    while (message.scrollWidth > message.clientWidth + 1 && size > 9) {
      size -= 0.5;
      message.style.setProperty('--pd-annonce-fit', `${size}px`);
    }
  }

  function initAnnonce(root) {
    if (!root || root.dataset.pdAnnonceReady) return;
    root.dataset.pdAnnonceReady = 'true';

    const messages = [...root.querySelectorAll('.pd-annonce__message')];
    const fitAll = () => messages.forEach(fit);
    fitAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    window.addEventListener('resize', fitAll);
    if (messages.length < 2) return;
    const interval = Number(root.dataset.interval) || 4000;
    let current = 0;
    let timer = null;

    const show = (index) => {
      current = (index + messages.length) % messages.length;
      messages.forEach((message, i) => {
        const active = i === current;
        message.classList.toggle('is-active', active);
        message.toggleAttribute('aria-hidden', !active);
        const link = message.querySelector('a');
        if (link) {
          if (active) link.removeAttribute('tabindex');
          else link.setAttribute('tabindex', '-1');
        }
      });
    };

    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      timer = setInterval(() => show(current + 1), interval);
    };

    const prev = root.querySelector('.pd-annonce__arrow--prev');
    const next = root.querySelector('.pd-annonce__arrow--next');
    if (prev) prev.addEventListener('click', () => { show(current - 1); start(); });
    if (next) next.addEventListener('click', () => { show(current + 1); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Éditeur : sélectionner un message l'affiche
    root.addEventListener('shopify:block:select', (event) => {
      const index = messages.findIndex((m) => m.contains(event.target) || m === event.target);
      if (index > -1) { show(index); stop(); }
    });
    root.addEventListener('shopify:block:deselect', start);

    start();
  }

  const initAll = (scope) => scope.querySelectorAll('[data-pd-annonce]').forEach(initAnnonce);

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
